
import { Editor } from '@tiptap/vue-2';
import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator';
import { TiptapMenuButton } from '../../types';
import QuickMenuButton from '../QuickMenuButton.vue';

@Component({
  components: {
    QuickMenuButton,
  },
})
export default class TiptapDropdownButton extends Vue {
  @Prop({ required: true }) readonly editor!: Editor;
  @Prop({ required: true }) readonly button!: TiptapMenuButton;
  @Prop({ type: Number, default: 0 }) readonly tabindex!: number;

  @Emit('show') emitShow(): void {}
  @Emit('blur') emitBlur(): void {}

  public isOpened: boolean = false;

  public closeMenu(): void {
    this.isOpened = false;
  }
}
